import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getBlogs,
  getBlog,
  createBlog,
  updateBlog,
  deleteBlog,
  changeStatus
} from '../api/blog';

/**
 * Get Paginated Blogs
 */
export const useBlogs = (page = 1, limit = 10) => {
  return useQuery({
    queryKey: ['blogs', page, limit],
    queryFn: () => getBlogs(page, limit),
    keepPreviousData: true,
  });
};

/**
 * Get Single Blog by ID
 */
export const useBlog = (id) => {
  return useQuery({
    queryKey: ['blog', id],
    queryFn: () => getBlog(id),
    enabled: !!id,
  });
};

/**
 * Create Blog
 */
export const useCreateBlog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createBlog,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blogs'] });
    },
  });
};

/**
 * Update Blog
 */
export const useUpdateBlog = ({ id, body }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }) => updateBlog(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blogs'] });
      queryClient.invalidateQueries({ queryKey: ['blog', id] });
    },
  });
};

/**
 * Delete Blog
 */
export const useDeleteBlog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteBlog,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blogs'] });
    },
  });
};

/**
 * Change Blog Status
 */
export const useChangeBlogStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: changeStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blogs'] });
    },
  });
};
